<template>
	<div>
		<div>
			<!-- <titlecom :title="download"></titlecom> -->
			<navigation></navigation>
			<div class="line"></div>
		</div>
		<div class="download">
			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E7%BB%86%E8%8F%8C%E7%9C%9F%E8%8F%8C%E6%84%9F%E6%9F%93%E5%AD%A6%E6%9C%AF%E4%BC%9A%E8%AE%AE%E9%80%9A%E7%9F%A5-BISC-2021.pdf"
			 style="color: #666; text-decoration: none;" target="_blank">
				<div class="title">会议通知pdf下载</div>
			</a>

			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/bisc2021-Enterprise-participation.pdf" style="color: #666; text-decoration: none;"
			 target="_blank">
				<div class="title">企业参会通知</div>
			</a>

			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E4%BC%81%E4%B8%9A%E5%9B%A2%E9%98%9F%E6%B3%A8%E5%86%8C%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%E8%A1%A8.xlsx"
			 style="color: #666; text-decoration: none;" target="_blank">
				<div class="title">企业团队注册信息收集表</div>
			</a>

			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E5%A7%94%E5%91%98%E6%8E%A8%E8%8D%90%E5%9B%A2%E9%98%9F%E6%B3%A8%E5%86%8C%E4%BF%A1%E6%81%AF%E6%94%B6%E9%9B%86%E8%A1%A8.xlsx"
			 style="color: #666; text-decoration: none;" target="_blank">
				<div class="title">委员推荐团队注册信息收集表</div>
			</a>
			
			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E6%84%9F%E6%9F%93%E5%8C%96%E7%96%97%E4%BC%9A%E8%AE%AE%E6%97%A5%E7%A8%8B.pdf"
			 style="color: #666; text-decoration: none;" target="_blank">
				<div class="title">感染化疗会议日程PDF下载</div>
			</a>

			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E4%B8%AD%E5%8D%8E%E5%8C%BB%E5%AD%A6%E4%BC%9A%E7%AC%AC%E4%B8%80%E6%AC%A1%E7%BB%86%E8%8F%8C%E7%9C%9F%E8%8F%8C%E6%84%9F%E6%9F%93%E5%AD%A6%E6%9C%AF%E4%BC%9A%E8%AE%AE%E6%97%A5%E7%A8%8B.pdf"
			 style="color: #666; text-decoration: none;" target="_blank">
				<div class="title">会议日程PDF下载</div>
			</a>

			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E4%BA%8C%E8%BD%AE%E9%80%9A%E7%9F%A5-BISC2021.pdf" style="color: #666; text-decoration: none;"
			 target="_blank">
				<div class="title">会议通知（第二轮）PDF下载</div>
			</a>
			
			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E7%94%B5%E5%AD%90%E5%A3%81%E6%8A%A5%E6%A8%A1%E6%9D%BF(BISC).pptx" style="color: #666; text-decoration: none;"
			 target="_blank">
				<div class="title">电子壁报模板(BISC)下载</div>
			</a>
			
			<a href="https://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/pdf/%E5%AD%A6%E5%88%86%E8%AF%B4%E6%98%8E.docx" style="color: #666; text-decoration: none;"
			 target="_blank">
				<div class="title">学分说明</div>
			</a>

		</div>
		<logocom style="margin-top: 460px;"></logocom>
	</div>
</template>

<script>
	// import titlecom from "@/components/title/title.vue";
	import navigation from '@/components/navigation/navigation.vue';
	import logocom from '@/components/logo/logo.vue';
	export default {
		data() {
			return {
				download: '资料下载'
			}
		},
		components: {
			// titlecom
			navigation,
			logocom
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (!flag) {
				this.$router.push({
					path: '/download'
				})
			}

		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';

	.download {
		color: #666;
		margin-top: 30px;
	}

	.title {
		color: #666;
		margin-top: 15px;
		// margin-left: 50%;
		// transform: translateX(-50%);
		text-align: center;
	}
</style>
